import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@teem/app/core/services/user.service';
import { environment } from '@teem/environments/environment';

declare var $: any;

@Component({
	selector: 'app-free-plan-expired-modal',
	templateUrl: './free-plan-expired-modal.component.html'
})
export class FreePlanExpiredModalComponent implements OnInit {
	@Input() userInfo;
	freeTrailDays = environment.freeTrailDays;
	experimentInfo: any;

	constructor(
		private router: Router,
		public activeModal: NgbActiveModal,
		private el: ElementRef,
		private userService: UserService,
	) {
	}

	ngOnInit(): void {
		this.experimentInfo = this.userInfo?.billing_experimente_data?.is_experiment == 1 ? true : false;
	}

	navigateToPlans() {
		// this.router.navigate(['/setting'], { queryParams: { 'tab': 'plans' } });

		// New plans
		this.router.navigate(['/subscription-plan']);

		// // Old plans
		// if (this.experimentInfo) {
        //     this.router.navigate(['/billing']);
        // } else {
        //     this.router.navigate(['/setting'], { queryParams: { 'tab': 'plans' } });
        // }

		this.userService.addLog(this.userInfo.email).subscribe((data: any) => {
			// this.loaderService.stopLoading();
		}, err => {
			// this.loaderService.stopLoading();
		})
		this.activeModal.close();
	}
}
